import { createAsyncAction } from 'typesafe-actions';

import { ResourceLite } from '../resources/createResource';
import { EntityBase, EntityID } from '../resources/types';

import sagaApi, { PayloadApiFailure, PayloadApiRequest, PayloadApiSuccess } from './sagaApi';

export interface RemovePayload<E extends EntityBase> extends PayloadApiRequest<E> {
  resource: ResourceLite<E>;
  method?: never;
  id?: EntityID;
}

const remove = createAsyncAction(
  '@lib/remove/REQUEST',
  '@lib/remove/SUCCESS',
  '@lib/remove/FAILURE',
  '@lib/remove/CANCEL',
)<RemovePayload<any>, PayloadApiSuccess<any>, PayloadApiFailure, any>();

// saga
export function* sagaRemove(action: ReturnType<typeof remove.request>) {
  const {
    payload: { resource, id, meta, ...config },
  } = action;

  // @ts-ignore
  return yield sagaApi({
    action: remove,
    resource,
    method: 'delete',
    url: id ? `${resource.url}/${id}` : resource.url,
    meta: {
      schema: resource.removeSchema,
      messageSuccess: resource.removeMessageSuccess,
      messageError: resource.removeMessageError,
      ...meta,
    },
    ...config,
  });
}

export default remove;
